export default __webpack_public_path__ + "images/8968fbbb9bb598d95109a718bf3682c4-do_10.png";